import { request } from '@umijs/max';

export async function queryDelegations(params) {
  return request('delegations/', {
    params: { ...params },
  });
}
